export class LoginPassword {
  constructor(public readonly userId: string, public readonly password: string) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/auth/login-password.ts